'use client';

import { Map } from 'lucide-react';
import React, { ButtonHTMLAttributes, ReactNode } from 'react';

export interface LocationListItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  title: string;
  description?: string;
  iconBgClass?: string; // e.g., 'bg-blue-100'
  iconTextClass?: string; // e.g., 'text-blue-500'
}

export const LocationListItem: React.FC<LocationListItemProps> = ({
  icon,
  title,
  description,
  iconBgClass = 'bg-orange-100',
  iconTextClass = 'text-orange-500',
  className,
  ...props
}) => {
  return (
    <button
      type="button"
      className={`flex items-center w-full py-2 hover:bg-gray-50 text-left cursor-pointer ${className || ''}`}
      {...props}
    >
      <div className={`flex items-center justify-center w-8 h-8 mr-3 rounded flex-shrink-0 ${iconBgClass}`}>
        {icon || <Map className={`w-6 h-6 ${iconTextClass}`} />}
      </div>
      <div>
        <div className="font-medium">{title}</div>
        {description && <div className="text-sm text-gray-500">{description}</div>}
      </div>
    </button>
  );
};
